/**
 * Local-hosted brand image URLs.
 * Served from our own backend at /api/static/hero/* — bypasses any third-party
 * CDN flakiness and keeps everything on the same domain as the rest of the site.
 *
 * Always import from here rather than hard-coding image URLs across pages,
 * so we never re-introduce the customer-assets dependency.
 */
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const STATIC = `${BACKEND_URL}/api/static/hero`;
const KITS = `${BACKEND_URL}/api/static/kits`;

export const PRESS_KIT_URL = `${BACKEND_URL}/api/static/epk/nina-capone-epk.pdf`;

export const OVA40_KIT = `${KITS}/ova40-kit.png`;
export const AUDIO_PORN_KIT = `${KITS}/audio-porn-kit.png`;

// Kit / physical album purchase links (Kit.com)
export const OVA40_KIT_URL = "https://ktbt.io/3Hw2Karz";
export const AUDIO_PORN_KIT_URL = "https://ktbt.io/QEBvtbnU";

// Physical CDs & Vinyl store (elasticstage)
export const ELASTICSTAGE_URL = "https://elasticstage.com/ninacapone";
export const OVA40_VINYL_URL = "https://elasticstage.com/ninacapone/releases/ova-40-album";

export const HERO_NINA = `${STATIC}/nina-hero.jpg`;
export const HERO_NINA_SECONDARY = `${STATIC}/nina-secondary.jpg`;
export const OVA40_COVER = `${STATIC}/ova40-cover.jpg`;
export const AUDIO_PORN_COVER = `${STATIC}/audio-porn-cover.jpg`;
export const AUDIO_PORN_FRONT = `${STATIC}/audio-porn-front.jpg`;
export const AUDIO_PORN_BACK = `${STATIC}/audio-porn-back.jpg`;
export const OVA40_VINYL_PHYSICAL = `${STATIC}/ova40-vinyl-physical.jpg`;
export const OVA40_VINYL_QR = `${STATIC}/ova40-vinyl-qr.png`;
